/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ProgramTypeFull,
  ProgramTypeFullOptional,
  ProgramTypeFullMetaI,
  ProgramTypeFullTrackedI,
} from "./program-type-full";
import {
  ProgramTypeFullTracked,
  ProgramTypeFullMeta,
} from "./program-type-full";

/**
 *
 * @export
 * @interface ProgramTypeDTO
 */
export interface ProgramTypeDTOOptional extends ProgramTypeFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof ProgramTypeDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProgramTypeDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof ProgramTypeDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof ProgramTypeDTO
   */
  programName?: string;
  /**
   *
   * @type {number}
   * @memberof ProgramTypeDTO
   */
  displayOrder?: number;
  /**
   * Y/N flag
   * @type {boolean}
   * @memberof ProgramTypeDTO
   */
  active?: boolean;
  /**
   *
   * @type {string}
   * @memberof ProgramTypeDTO
   */
  colorDisplay?: string;
}

export interface ProgramTypeDTO
  extends ProgramTypeDTOOptional, ProgramTypeFull {
  /**
   *
   * @type {boolean}
   * @memberof ProgramTypeDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProgramTypeDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof ProgramTypeDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof ProgramTypeDTO
   */
  programName?: string;
  /**
   *
   * @type {number}
   * @memberof ProgramTypeDTO
   */
  displayOrder?: number;
  /**
   * Y/N flag
   * @type {boolean}
   * @memberof ProgramTypeDTO
   */
  active?: boolean;
  /**
   *
   * @type {string}
   * @memberof ProgramTypeDTO
   */
  colorDisplay?: string;
}

export interface ProgramTypeDTOTrackedI extends ProgramTypeFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof ProgramTypeDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProgramTypeDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ProgramTypeDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ProgramTypeDTO
   */
  programName?: string;
  programNameIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ProgramTypeDTO
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   * Y/N flag
   * @type {boolean}
   * @memberof ProgramTypeDTO
   */
  active?: boolean;
  activeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ProgramTypeDTO
   */
  colorDisplay?: string;
  colorDisplayIsSet: boolean;
}

transformDatesMap.set("ProgramTypeDTO", function (model: ProgramTypeDTO) {});

export type ProgramTypeDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  programName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  colorDisplay: PropertyMeta<MetaTypeBase<string>>;
}>;

export var ProgramTypeDTOMeta: ProgramTypeDTOMetaI = {} as ProgramTypeDTOMetaI;
ProgramTypeDTOMeta = typeMeta("ProgramTypeDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  programName: propertyMeta(
    "programName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  colorDisplay: propertyMeta(
    "colorDisplay",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = ProgramTypeDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ProgramTypeFullMeta]);
  metaI.isDeleted.inheritedFrom = ProgramTypeFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = ProgramTypeFullMeta.isNew;
  metaI.assignId.inheritedFrom = ProgramTypeFullMeta.assignId;
  metaI.programName.inheritedFrom = ProgramTypeFullMeta.programName;
  metaI.displayOrder.inheritedFrom = ProgramTypeFullMeta.displayOrder;
  metaI.active.inheritedFrom = ProgramTypeFullMeta.active;
  metaI.colorDisplay.inheritedFrom = ProgramTypeFullMeta.colorDisplay;
});

export class ProgramTypeDTOTracked
  extends ProgramTypeFullTracked
  implements ProgramTypeDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  programName__I?: string = undefined;
  programNameIsSet: boolean = false;
  set programName(v: undefined | string) {
    if (v !== undefined) {
      this.programName__I = v;
      this.programNameIsSet = true;
    } else {
      this.programName__I = v || undefined;
      this.programNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get programName() {
    return this.programName__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  colorDisplay__I?: string = undefined;
  colorDisplayIsSet: boolean = false;
  set colorDisplay(v: undefined | string) {
    if (v !== undefined) {
      this.colorDisplay__I = v;
      this.colorDisplayIsSet = true;
    } else {
      this.colorDisplay__I = v || undefined;
      this.colorDisplayIsSet = false;
    }
    this.changeTracker = true;
  }
  get colorDisplay() {
    return this.colorDisplay__I;
  }
  constructor(config?: ProgramTypeDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: ProgramTypeDTOOptional,
    options?: AssignOptions,
  ): ProgramTypeDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.programName &&
      this.programNameApplyFilter(optionsRequired.filter)
    ) {
      this.programName = config.programName;
      if (optionsRequired.unassign) this.programNameIsSet = false;
      else this.programNameIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (
      config.colorDisplay &&
      this.colorDisplayApplyFilter(optionsRequired.filter)
    ) {
      this.colorDisplay = config.colorDisplay;
      if (optionsRequired.unassign) this.colorDisplayIsSet = false;
      else this.colorDisplayIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ProgramTypeDTOTrackedI {
    const cloned = {} as ProgramTypeDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.programNameIsSetDeep() &&
      this.programNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.programNameIsSet = true;
      cloned.programName = this.programName;
    } else {
      //cloned.programNameIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (
      this.colorDisplayIsSetDeep() &&
      this.colorDisplayApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.colorDisplayIsSet = true;
      cloned.colorDisplay = this.colorDisplay;
    } else {
      //cloned.colorDisplayIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ProgramTypeDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.programNameApplyFilter(filter)) this.programNameIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    if (!this.colorDisplayApplyFilter(filter)) this.colorDisplayIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProgramTypeDTOMeta.isDeleted,
      ProgramTypeDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProgramTypeDTOMeta.isNew,
      ProgramTypeDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProgramTypeDTOMeta.assignId,
      ProgramTypeDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  programNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProgramTypeDTOMeta.programName,
      ProgramTypeDTOMeta,
      this.programName,
      this,
    );
  }
  programNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.programNameIsSet && this.programNameApplyFilter(filter))
      return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProgramTypeDTOMeta.displayOrder,
      ProgramTypeDTOMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProgramTypeDTOMeta.active,
      ProgramTypeDTOMeta,
      this.active,
      this,
    );
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  colorDisplayApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProgramTypeDTOMeta.colorDisplay,
      ProgramTypeDTOMeta,
      this.colorDisplay,
      this,
    );
  }
  colorDisplayIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.colorDisplayIsSet && this.colorDisplayApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.programNameIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    if (this.colorDisplayIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
